exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".form.ui.buttonWithForm__form>.fields:not(:last-child){margin-bottom:.833em}", ""]);

